<template>
  <div class="loading-game">
    <div class="energy-grid"></div>

    <div class="loading-card">
      <div class="logo-orb">
        <img
          :src="require('@/assets/logo_electroliga.svg')"
          alt="ElectroLiga logo"
          class="loading-logo"
        />
      </div>

      <div class="loading-title">
        ElectroLiga
      </div>

      <div class="loading-subtitle">
        {{ text }}
      </div>

      <div class="energy-bar">
        <div class="energy-fill"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
props: {
    text: {
      type: String,
      default: "Conectando con la red eléctrica...",
    },
    },
  data() {
    return {
      texts: [
        "Conectando con la red eléctrica...",
        "Sincronizando mercado diario...",
        "Cargando tu compañía energética...",
      ],
      currentIndex: 0,
      interval: null,
    };
  },

  computed: {
    currentText() {
      return this.texts[this.currentIndex];
    },
  },

  mounted() {
    this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.texts.length;
    }, 500);
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.loading-game {
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, rgba(34, 197, 94, 0.25), transparent 32%),
    radial-gradient(circle at bottom right, rgba(56, 189, 248, 0.22), transparent 34%),
    linear-gradient(135deg, #06111f 0%, #0f172a 55%, #111827 100%);
}

.energy-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: radial-gradient(circle, black 0%, transparent 75%);
  opacity: 0.7;
}

.loading-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 380px;
  padding: 34px 26px;
  border-radius: 30px;
  text-align: center;
  color: white;
  background: rgba(255, 255, 255, 0.09);
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow: 0 26px 90px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(18px);
  animation: cardIn 0.65s ease both;
}

.logo-orb {
  width: 108px;
  height: 108px;
  margin: 0 auto 18px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;

  background:
    radial-gradient(circle at 50% 42%,
      rgba(255, 255, 255, 0.20) 0%,
      rgba(45, 212, 191, 0.22) 34%,
      rgba(15, 23, 42, 0.78) 100%
    );

  border: 1px solid rgba(255, 255, 255, 0.18);

  box-shadow:
    0 0 18px rgba(34, 197, 94, 0.35),
    0 0 42px rgba(45, 212, 191, 0.22);

  animation: pulseEnergy 1.8s infinite ease-in-out;
}

.loading-logo {
  width: 90px;
  height: 90px;
  object-fit: contain;
  position: relative;
  z-index: 2;

  filter:
    drop-shadow(0 2px 4px rgba(0, 0, 0, 0.45))
    drop-shadow(0 0 8px rgba(255, 255, 255, 0.18));
}

.logo-orb span {
  font-size: 48px;
  color: #06111f;
}

.loading-title {
  font-family: "Orbitron", sans-serif !important;
  font-size: 32px;
  font-weight: 800;
  letter-spacing: 1px;
}

.loading-subtitle {
  min-height: 22px;
  margin: 12px 0 26px;
  font-size: 14px;
  color: rgba(255,255,255,0.75);
}

.energy-bar {
  height: 10px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(255,255,255,0.14);
}

.energy-fill {
  height: 100%;
  width: 48%;
  border-radius: inherit;
  background: linear-gradient(90deg, #22c55e, #38bdf8, #a855f7);
  animation: loadingBar 1.25s infinite ease-in-out;
}

@keyframes loadingBar {
  0% {
    transform: translateX(-130%);
    width: 45%;
  }

  50% {
    width: 72%;
  }

  100% {
    transform: translateX(240%);
    width: 45%;
  }
}

@keyframes pulseEnergy {
  0%, 100% {
    transform: scale(1);
    filter: brightness(1);
  }

  50% {
    transform: scale(1.08);
    filter: brightness(1.25);
  }
}

@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>